module.exports = __webpack_public_path__ + "img/ads2.1bb4799.webp";